<template>
    <div class="Columns-page">
        <div class="sub-container">
            <!--            <div class="breadcrumbs">-->
            <!--                <ul>-->
            <!--                    <li><a :href="$store.state.hrefPrefix + '/'">{{ $t('home') }}</a></li>-->
            <!--                    <li><img src="/assets/images/pagination-right.svg" alt=""/></li>-->
            <!--                    <li> {{ $t('author') }}</li>-->
            <!--                    <li><img src="/assets/images/pagination-right.svg" alt=""/></li>-->
            <!--                    <li>{{ author.author_languages[0].pivot.name }}</li>-->
            <!--                </ul>-->
            <!--            </div>-->
            <h1>{{ $t('author')}}</h1>
        </div>
        <div class="sub-container" style="margin-top: 25px">
            <i v-if="author.blob != null"
               style="width: 120px;height: 120px; display: inline-block;border-radius: 100px">
                <img class="avatar-img" :src="author.blob.url" alt=""/></i>
            <h2>
                {{ author.author_languages[0].pivot.name }}
            </h2>
            <div v-if="author.twitter_account != null && author.twitter_account !== ''"
                 style="margin-bottom: 12px;margin-top: 12px">
                <a :href="'https://twitter.com/' + author.twitter_account">
                    <span style="direction: ltr;display: inline" class="twitter-links">@{{
                            author.twitter_account
                        }}</span></a>
            </div>
            <div class="Columns-intro"
                 v-if="author.author_languages[0].pivot.bio != null && author.author_languages[0].pivot.bio !== ''">
<!--                <span>{{ $t('know_me_more') }} </span>-->
                <p>{{ author.author_languages[0].pivot.bio }}</p>
            </div>
        </div>
        <div class="sub-container" style="margin-top: 24px">
            <div class="row">
                <selected-column-article v-for="article in articles.data" :article="article"></selected-column-article>
            </div>
            <div class="pagination-row">
                <a class="paginate-link" :href="articles.links[0].url">&#60;</a>
                <template v-for="(link, index) in articles.links">
                    <a class="paginate-link" :href="link.url"><p :class="{'active' : link.active}"
                                                                 v-if="index !== 0 && index !== articles.links.length - 1">
                        {{ link.label }}</p></a>
                </template>
                <a class="paginate-link" :href="articles.links[articles.links.length - 1].url">&#62;</a>
            </div>
        </div>
    </div>

</template>

<script>


import AnalysisMiddleFeatureArticle from "@/parts/categories/CategoryMiddleArticle.vue";
import AnalysisColumnsMiddleFeatureArticle from "@/parts/categories/CategoryColumnsMiddleArticle.vue";
import Columns from "@/parts/Columns/Columns.vue";
import SelectedColumnArticle from "@/parts/Columns/SelectedCoulmnArticle.vue";

export default {
    name: "AuthorPage",
    computed: {},
    components: {SelectedColumnArticle, Columns, AnalysisColumnsMiddleFeatureArticle, AnalysisMiddleFeatureArticle},
    props: {
        author: {
            type: Object,
            default: {}
        },
        articles: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {}
    }
}
</script>

<style scoped>
.avatar-img {
    border-radius: 100px;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
